import { Directive, HostListener, ElementRef } from '@angular/core';

@Directive({
  selector: 'textarea[autoResize]',
  standalone: true,
})
export class AutoResizeDirective {
  @HostListener('input', ['$event.target'])
  onInput(textArea: HTMLTextAreaElement): void {
    this.adjust(textArea);
  }

  constructor(public element: ElementRef) {
  }

  ngOnInit(): void {
    setTimeout(() => this.adjust(), 0);
  }

  adjust(textArea?: HTMLTextAreaElement): void {
    textArea = textArea || this.element.nativeElement;
    textArea!.style.overflow = 'hidden';
    textArea!.style.height = 'auto';
    textArea!.style.height = (textArea!.scrollHeight + 40) + 'px';
  }
}